export const styles = {
  container:
    'tw-w-full tw-rounded tw-p-4 tw-bg-white tw-border tw-border-neutral-200 tw-shadow-sm',
  title: 'tw-text-base tw-font-semibold tw-text-neutral-800 tw-m-0 tw-mb-3 tw-pb-3 tw-border-b tw-border-neutral-200',
  row: 'tw-flex tw-flex-wrap tw-items-center tw-gap-x-6 tw-gap-y-2 tw-text-sm',
  field: 'tw-flex tw-items-center tw-gap-1.5 tw-shrink-0',
  label: 'tw-font-medium tw-text-neutral-500 tw-shrink-0',
  value: 'tw-text-neutral-900',
  divider: 'tw-w-px tw-h-4 tw-bg-neutral-200 tw-shrink-0',
};
